export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'USDC', 'USDT'];
export function isSupportedCurrency(currency) {
    return typeof currency === 'string' && SUPPORTED_CURRENCIES.includes(currency);
}
